import { Injectable } from '@angular/core';
import { catchError, retry } from "rxjs/operators";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { AlertService, IAlertType } from "./alert.service";
import { Observable, throwError } from "rxjs";
import { Notification as PpsNotification, NotificationForm, NotificationList, SingleNotification, WebserviceResponse} from "../interfaces";
import { restBaseUrl } from "../utils/rest-url";

@Injectable({
  providedIn: 'root'
})
export class NotificationStoreService {

  private readonly endpoint = restBaseUrl('/notifications');

  constructor(
      private http: HttpClient,
      private alertDispatcher: AlertService
  ) { }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Server-side error code: ${error.status} - message: ${error.message}`;
    }
    // window.alert(errorMessage);

    this.alertDispatcher.show({
      message: errorMessage,
      clrAlertType: IAlertType.DANGER
    }, 5000);

    // return throwError(errorMessage); deprecated
    return throwError(() => new Error(errorMessage));
  }

  // Main CRUD Services

  public getNotification(projectID:string, notificationID: number, jobID: number, order_pps: number, type: number): Observable<WebserviceResponse<PpsNotification[]>> {
    const options = new HttpParams({
      fromObject: {
        project_id: projectID,
        notification_id: notificationID,
        job_id: jobID,
        order_pps: order_pps,
        notification_type: type.toString()
      }
    });
    return this.http.get<WebserviceResponse<PpsNotification[]>>(this.endpoint + '/get_notifications',
        { params: options }
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public getSingleNotification(projectID:string, notificationID: number): Observable<WebserviceResponse<SingleNotification[]>> {
    const options = new HttpParams({
      fromObject: {
        project_id: projectID,
        notification_id: notificationID,
        job_id: 0,
        order_pps: '0',
        notification_type: 0
      }
    });
    return this.http.get<WebserviceResponse<SingleNotification[]>>(this.endpoint + '/get_notifications',
      { params: options }
    ).pipe(
      retry(3),
      catchError(this.handleError.bind(this))
    );
  }

  createNotification(projectID: string, jobID: number, orderID: number, notificationType: number): Observable<WebserviceResponse<boolean>> {
    let subject: string = ''
    return this.http.post<WebserviceResponse<boolean>>(
        `${this.endpoint}/add_notification?project_id=${projectID}&job_id=${jobID}&order_id=${orderID}&notification_type=${notificationType}&subject=${subject}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateNotification(trans: NotificationForm) {
    return this.http.put(
        `${this.endpoint}/update_notification`,
        trans,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public deleteNotification(projectID: string, notificationID: number ){
    return this.http.delete(
        `${this.endpoint}/delete_notification?notification_id=${notificationID}&project_id=${projectID}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }


  public getNotificationsPositions(projectnumber: string, notificationID: number, positionID: number, partID: number): Observable<WebserviceResponse<NotificationList[]>> {
    const options = new HttpParams({
      fromObject: {
        project_id: projectnumber,
        notification_id: notificationID,
        position: positionID,
        part: partID
      }
    });
    return this.http.get<WebserviceResponse<NotificationList[]>>(this.endpoint + '/get_notification_position',
        { params: options }).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateNotificationsPosition(notification: NotificationList) {
    return this.http.put(
        `${this.endpoint}/update_notification_position`,
        notification,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public deleteNotificationsPosition(projectID: string, notificationID: number, positionID: number, partID: number) {
    return this.http.delete(
        `${this.endpoint}/delete_notification_position?project_id=${projectID}&notification_id=${notificationID}&position=${positionID}&part=${partID}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }
}
